import { useState, useRef } from "react";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

const AudioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current
        .play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch((err) => console.warn("Play failed:", err));
    }
  };

  return (
    <div className="relative flex justify-center items-center right-2 sm:right-8">
      <audio ref={audioRef} src="/music.mp3" loop preload="auto" playsInline />
      <div className="relative flex justify-center items-center">
        {isPlaying && (
          <>
            <span className="absolute w-10 h-10 rounded-full border-2 border-[#e60f87] animate-wave"></span>
            <span className="absolute w-12 h-12 rounded-full border-2 border-[#e60f85bf] animate-wave delay-200"></span>
            <span className="absolute w-14 h-14 rounded-full border-2 border-pink-500 animate-wave delay-400"></span>
          </>
        )}
        <button
          onClick={togglePlay}
          className={`relative px-[10px] py-2 rounded-full shadow bg-pink-700 text-white transition-all duration-300 ${
            isPlaying ? "animate-glow" : ""
          }`}
        >
          {isPlaying ? (
            <VolumeUpIcon fontSize="medium" />
          ) : (
            <VolumeOffIcon fontSize="medium" />
          )}
        </button>
      </div>
    </div>
  );
};

export default AudioPlayer;
